<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-05 09:33:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-14 14:48:34
-->
<template>
  <v-card :loading="cardLoading">
    <v-card-title>
      <mrc_ess_searchInput
        :isShow="true"
        v-model="search"
        @keydown="keydown"
        @change="change"
        style="width: 100%"
        :appendShow="false"
      ></mrc_ess_searchInput>
    </v-card-title>
    <v-card-text>
      <div
        class="top pb-2"
        :style="{ 'max-height': maxHeight + 'px', overflowX: 'hidden' }"
      >
        <v-treeview
          dense
          :search="search"
          selected-color="primary"
          :items="allList"
          selection-type="independent"
          :return-object="true"
          open-all
          item-disabled="disabled"
          @input="treeInput"
          :item-text="itemText"
          :item-key="itemKey"
        >
          <template v-slot:prepend="{ open }">
            <v-icon>
              {{ open ? "mdi-folder-open" : "mdi-folder" }}
            </v-icon>
          </template>

          <template v-slot:label="{ item }">
            <span
              style="
                position: relative;
                display: inline-block;
                height: 40px;
                line-height: 40px;
              "
            >
              {{ INT(item[itemText]) }}
              <span
                class="gesture"
                @click.stop="item.readonly ? '' : getDetail(item)"
                style="
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  background-color: darkred;
                  opacity: 0;
                "
              ></span>
            </span>
          </template>

          <template v-slot:append="{ item }">
            <v-icon
              class="material-icons mr-3"
              v-if="item.active"
              style="color: rgb(19, 166, 113)"
            >
              check_circle
            </v-icon>
          </template>
        </v-treeview>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 *
 *
 *
 *
 * @detailStaff 获取员工的详情数据
 * @selectAll  选择列表中的全部员工
 * @getDetail
 */
export default {
  components: {},
  props: {
    allList: {
      //树结构
      type: Array,
      default: () => [],
    },
    cardLoading: {
      //列表加载状态 默认不显示
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: String,
      default: "382",
    },
    itemText: {
      type: String,
    },
    itemKey: {
      type: String,
    },
  },
  model: {
    prop: "allList",
    event: "changeAllList",
  },
  data() {
    return {
      search: null, //搜索值
      caseSensitive: false, //区分大小写
      open: [1, 2],
      // selectAllStatus: false,//全选状态 默认不全选
      timeout: null,
      selection: [],
      allParentNodes: false,
      trueStatus: [],
    };
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {},

  methods: {
    keydown(v) {},
    change(v) {},
    async getDetail(item) {
      if (this.timeout !== null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        let res = this.$clone(this.allList);
        await this.changeActive(res, item.uuid);
        await this.changeReadonly(res, item.uuid);
        // this.changeParents(res)
        // console.log(res);
        this.$emit("changeAllList", res);
      }, 500);
    },
    treeInput(val) {},
    activeUpdate(val) {},
    changeActive(arr, uuid) {
      //改变当前点击节点的状态
      arr.map((item, index) => {
        if (item.uuid == uuid) {
          this.$set(arr, index, { ...item, active: !item.active });
          if (item.children && item.children.length > 0) {
            this.recursionActive(item.children, !item.active);
          }
        } else {
          if (item.children && item.children.length > 0) {
            this.changeActive(item.children, uuid);
          }
        }
      });
    },
    changeReadonly(arr, uuid) {
      //递归改变当前节点 是否只读状态
      arr.map((item, index) => {
        if (item.uuid == uuid) {
          if (item.children && item.children.length > 0) {
            this.recursionReadonly(item.children, item.active);
          }
        } else {
          if (item.children && item.children.length > 0) {
            this.changeReadonly(item.children, uuid);
          }
        }
      });
    },
    recursionActive(arr, val) {
      //递归将子节点变为 父节点的状态
      arr.map((item, index) => {
        this.$set(arr, index, { ...item, active: val });
        if (item.children && item.children.length > 0) {
          this.recursionActive(item.children, val);
        }
      });
    },
    recursionReadonly(arr, val) {
      //递归将子节点变为 变为父节点的禁用状态
      arr.map((item, index) => {
        this.$set(arr, index, { ...item, readonly: val });
        if (item.children && item.children.length > 0) {
          this.recursionReadonly(item.children, val);
        }
      });
    },
    changeParents(arr) {
      //递归根据子节点改变父节点状态
      arr.map((item, index) => {
        if (item.children && item.children.length > 0) {
          // if (item.children.every(item1 => {
          //   return item1.active == true
          // })) {
          //   this.$set(arr, index, { ...item, active: true })
          //   this.recursionActive(item.children, true)
          // }
          this.trueStatus = [];
          this.checkStatus(item.children);
          if (
            this.trueStatus.every((item) => {
              return item == true;
            })
          ) {
            this.$set(arr, index, { ...item, active: true });
            this.recursionActive(item.children, true);
          } else {
            this.$set(arr, index, { ...item, active: false });
            this.changeParents(item.children);
          }
        }
      });
    },
    checkStatus(arr) {
      // 递归获取子节点全部数据  重点
      arr.map((item) => {
        if (!item.children || item.children == 0) {
          this.trueStatus.push(item.active);
        }
        if (item.children && item.children.length > 0) {
          this.checkStatus(item.children);
        }
      });
    },
    recursionChengji(arr, otr) {
      //递归加层级
      arr.map((item, index) => {
        this.$set(arr, index, { ...item, otr: otr + item[this.itemText] });
        if (item.children && item.children.length > 0) {
          let od = otr + item[this.itemText] + ">";
          this.recursionChengji(item.children, od);
        }
      });
    },
  },
};
</script>

<style scoped>
.top {
  border: 2px solid #ececec;
  overflow-y: auto;
}
.gesture:hover {
  cursor: pointer;
}
</style>
